// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".input_width[data-v-3409b53a] {\n  width: 330px;\n}", ""]);
// Exports
module.exports = exports;
